function produit()
{
  jQuery(function($) {
    $('.child-products ul.products').slick({
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      responsive: [
        {
          breakpoint: 999999,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
          }
        }
      ],
    });

    //Scroll to first product groups
    $('.anchor-link').click(function() {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#group-1").offset().top - $('.header-top').height() - 50 - 60
      }, 1500);
    });


    //Add to favorite button
    $('.single-product').on('ajax:get:product-fav-or-unfav:success', 'button.fav-button', function(response, data) {
      $(this).replaceWith(data.button);
    });
    $('.gamme-product').on('ajax:get:product-fav-or-unfav:success', 'button.fav-button', function(response, data) {
      $(this).replaceWith(data.button);
    });

    $('.woocommerce-account .product').on('ajax:get:product-fav-or-unfav:success', 'button.fav-button', function() {
      $(this).closest('.product').remove();
    });


    //Add videos to WC product gallery
    let $newSlide = $('.video-slide');
    $('.flex-control-nav').append($newSlide);
    $newSlide.removeClass('hide');

    $newSlide.click(function() {
      $('.flex-active').trigger('click');
    })

    let slick = $('.flex-control-nav').slick({
      slidesToShow: 3,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
    });

    $newSlide.find('a').fancybox({
      beforeClose: function() {
        let width = $('.woocommerce-product-gallery__image').width();
        let index = parseInt($newSlide.attr('data-slick-index'));
        let translate = (index-1) * width;
        $('.woocommerce-product-gallery__wrapper').css('transform', 'translate3d(-'+ translate +'px, 0px, 0px)');
      }
    });

    //Slick page produit gamme
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav',
    });

    $('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      focusOnSelect: true,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
    });

    //Disable right click
    $(".product-pictures, .woocommerce-product-gallery").on("contextmenu",function(){
      return false;
    });

    $('.product-description').on('click', '.read-more-btn', function() {
      $(this).closest('.product-description').find('.description ul').slideToggle();
      $(this).toggleClass('active');
    });

    // AJAX add to cart button on products lists.
    $(document).on('click', '.add_to_cart_button.ajax_add_to_cart', function (e) {
      e.preventDefault();

      const btn = this;
      const id = $(btn).attr('data-id') || null;
      const quantity = $(btn).attr('data-quantity') || 1;

      if (!id) return;

      const data = {
        action: 'woocommerce_ajax_add_to_cart',
        product_id: id,
        quantity: quantity,
      };

      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
        data: data,
        dataType: 'json',
        beforeSend: function (response) {
          $(btn).addClass('loading');
        },
        complete: function (response) {
          $(btn).removeClass('loading');
        },
        success: function (response) {
          if (!response) {
            return;
          }

          if (response.error && response.product_url) {
            window.location = response.product_url;
            return;
          }

          // Redirect to cart option
          if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
            window.location = wc_add_to_cart_params.cart_url;
            return;
          }

          // Trigger event so themes can refresh other areas.
          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $(btn)]);

          $(btn).siblings('.added_to_cart_button').removeClass('hidden');
          $(btn).remove();
        }
      })
    });
  });
}

export { produit };
